import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Injectable } from '@angular/core';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { Plantillas } from 'src/app/_models/formularios/plantillas.model';
import { ZeroService } from 'src/app/_services/zero/zero.service';


@Component({
  selector: 'app-modaledit-plantilla',
  templateUrl: './modaledit-plantilla.component.html',

})
export class ModalEditPlantillaComponent extends MzBaseModal {
  public plantilla: Plantillas;
  @ViewChild('DSCPLANTILLA') DSCPLANTILLA: ElementRef;
  @ViewChild('POSICIONP') POSICION: ElementRef;
  @ViewChild('ErrorEditPlantilla') ErrorEditPlantilla: MzModalComponent;
  // datos de entrada por el servicio de modal
  @Input() public idPlantillaPk: number;
  @Input() public dsc: string;
  @Input() public posicion: number;
  // Emitter para envío de parámetros
  @Output() updatePlantilla: EventEmitter<Plantillas>;
  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };

  constructor(private zeroService: ZeroService) {
    super();
    this.updatePlantilla = new EventEmitter();
    this.plantilla = new Plantillas();
  }

  ngOnInit() {
    this.plantilla.idAnt = this.idPlantillaPk;
    this.plantilla.dsc = this.dsc;
    this.plantilla.posicion = this.posicion;
  }
  cancelar() {
    this.modalComponent.closeModal();
  }
  // Aceptando el modal 
  public closeModal() {
    this.plantilla.idPlantillaPk = this.idPlantillaPk;
    this.plantilla.dsc = this.DSCPLANTILLA.nativeElement.value;
    this.plantilla.posicion = this.POSICION.nativeElement.value;
    this.plantilla.dsc = this.plantilla.dsc.trim();
    if (this.plantilla.idPlantillaPk == null ||
      this.plantilla.dsc == null ||
      this.plantilla.dsc.trim().length == 0 ||
      this.plantilla.posicion == null) {
      this.ErrorEditPlantilla.openModal();
    } else {
        this.updatePlantilla.emit(this.plantilla);
        this.modalComponent.closeModal();
      }
    }
  }
